import { getAppointment } from "../../api/Scheduling/appointments";

// Ask only when the scheduled appointment is still in the future. Yes frees that
// time for a new booking. No keeps it closed. Either answer still completes the visit.
export async function chooseFreeAppointmentTime(encounter, confirm = (message) => window.confirm(message)) {
  const appointmentId = encounter?.appointmentId;
  const organizationRef = encounter?.orgId || String(encounter?.serviceProvider?.reference || "").split("/")[1];
  if (!appointmentId || !organizationRef) return undefined;
  let endsAt;
  try {
    const result = await getAppointment({ organizationRef, appointmentId });
    const appointment = result?.appointment || result;
    endsAt = appointment?.endsAt;
  } catch {
    return false;
  }
  const end = new Date(endsAt).getTime();
  if (!endsAt || Number.isNaN(end) || Date.now() >= end) return false;
  return confirm("You are finishing before this appointment ends. Do you want to free your time for new bookings?") === true;
}
